import { render, staticRenderFns } from "./Sentiment.vue?vue&type=template&id=9f5c82de&scoped=true&"
import script from "./Sentiment.vue?vue&type=script&lang=js&"
export * from "./Sentiment.vue?vue&type=script&lang=js&"
import style0 from "./Sentiment.vue?vue&type=style&index=0&id=9f5c82de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5c82de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VApp,VCard,VCheckbox,VChip,VDivider,VFlex,VLayout,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle,VTooltip})
